/* Sunoire desktop vertical thumbnail controls. */
(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  const getStep = (list) => {
    const item = list.querySelector('.thumbnail-list__item');
    if (!item) return 140;
    const styles = window.getComputedStyle(list);
    const gap = Number.parseFloat(styles.rowGap || styles.gap || '0') || 0;
    return item.getBoundingClientRect().height + gap;
  };

  const updateButtons = (slider, list) => {
    const maxScroll = Math.max(0, list.scrollHeight - list.clientHeight - 1);
    const previous = slider.querySelector('.slider-button--prev');
    const next = slider.querySelector('.slider-button--next');
    const offset = Number(slider.dataset.sunoireThumbOffset || 0);
    if (previous) previous.disabled = offset <= 1;
    if (next) next.disabled = offset >= maxScroll;
  };

  const scrollThumbs = (slider, direction) => {
    const list = slider.querySelector('.thumbnail-list');
    if (!list) return;

    const maxScroll = Math.max(0, list.scrollHeight - list.clientHeight);
    const currentOffset = Number(slider.dataset.sunoireThumbOffset || 0);
    const step = getStep(list);
    const target = Math.max(0, Math.min(maxScroll, currentOffset + step * direction));
    slider.dataset.sunoireThumbOffset = String(Math.round(target));
    slider.dataset.sunoireThumbStep = String(Math.round(step));
    slider.dataset.sunoireThumbTarget = String(Math.round(target));
    list.style.setProperty('--sunoire-thumb-offset', `${target * -1}px`);
    list.querySelectorAll('.thumbnail-list__item').forEach((item) => {
      item.style.setProperty('top', `${target * -1}px`, 'important');
      item.style.setProperty('transform', `translateY(${target * -1}px)`, 'important');
    });

    window.setTimeout(() => {
      updateButtons(slider, list);
    }, 380);
  };

  const handleThumbControl = (event) => {
    if (!desktopQuery.matches) return;

    const button = event.target.closest?.('product-info[id^="MainProduct-"] slider-component[id^="GalleryThumbnails"] .slider-button--prev, product-info[id^="MainProduct-"] slider-component[id^="GalleryThumbnails"] .slider-button--next');
    if (!button || button.disabled) return;

    const slider = button.closest('slider-component[id^="GalleryThumbnails"]');
    if (!slider) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    const now = Date.now();
    const lastAction = Number(slider.dataset.sunoireThumbLastAction || 0);
    if (now - lastAction < 260) return;

    slider.dataset.sunoireThumbLastAction = String(now);
    scrollThumbs(slider, button.classList.contains('slider-button--next') ? 1 : -1);
  };

  if (window.sunoirePdpVerticalThumbsClickReady !== true) {
    window.sunoirePdpVerticalThumbsClickReady = true;

    ['pointerdown', 'mousedown', 'click'].forEach((eventName) => {
      window.addEventListener(eventName, handleThumbControl, true);
      document.addEventListener(eventName, handleThumbControl, true);
    });
  }

  const setupSunoirePdpVerticalThumbs = (root = document) => {
    if (!desktopQuery.matches) return;

    root.querySelectorAll('product-info[id^="MainProduct-"] slider-component[id^="GalleryThumbnails"]').forEach((slider) => {
      if (slider.dataset.sunoireVerticalThumbsReady === 'true') return;

      const list = slider.querySelector('.thumbnail-list');
      if (!list) return;

      slider.dataset.sunoireVerticalThumbsReady = 'true';

      slider.querySelectorAll('.slider-button--prev, .slider-button--next').forEach((button) => {
        button.addEventListener('click', handleThumbControl, true);
        button.addEventListener('pointerdown', handleThumbControl, true);
        button.addEventListener('mousedown', handleThumbControl, true);
      });

      slider.dataset.sunoireThumbOffset = slider.dataset.sunoireThumbOffset || '0';
      list.style.setProperty('--sunoire-thumb-offset', `${Number(slider.dataset.sunoireThumbOffset || 0) * -1}px`);
      list.querySelectorAll('.thumbnail-list__item').forEach((item) => {
        item.style.setProperty('top', `${Number(slider.dataset.sunoireThumbOffset || 0) * -1}px`, 'important');
        item.style.setProperty('transform', `translateY(${Number(slider.dataset.sunoireThumbOffset || 0) * -1}px)`, 'important');
      });
      list.addEventListener('scroll', () => updateButtons(slider, list), { passive: true });
      window.addEventListener('resize', () => updateButtons(slider, list), { passive: true });
      updateButtons(slider, list);
    });
  };

  const refresh = () => setupSunoirePdpVerticalThumbs();

  window.addEventListener('load', refresh);
  document.addEventListener('shopify:section:load', (event) => setupSunoirePdpVerticalThumbs(event.target));

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', refresh);
  } else {
    desktopQuery.addListener(refresh);
  }
})();
